import { useInfiniteQuery } from 'react-query'
import { getTransactions } from 'services/transactions'

export type TMyTransactionsQuery = Omit<IDashboardTransactionsParams, 'cursor'>

export default function useGetTransactions(query: TMyTransactionsQuery) {
    return useInfiniteQuery(
        // Its own key: this used to share `money-pools-detail-users-in-funds`
        // with a fund's member list, so invalidating one refetched the other.
        // Every filter is in it, so going back to one is instant.
        ['my-transactions', query],
        ({ pageParam = 1 }) => getTransactions({ ...query, cursor: pageParam }),
        {
            // `next` is read as a flag, not followed: a server older than the
            // filters drops the query string from it.
            getNextPageParam: (lastPage, allPages) =>
                lastPage?.next ? allPages.length + 1 : undefined,
        }
    )
}
